<template>
  <form>
    <shop-copy v-if="isNew" @selected="selected" :edit-mode="editMode" :helper="helper" />
    <form @submit="submitForm">
        <shop-form
        @keyaccountselected="setKeyAccountId"
        :data.sync="shop"
        :touched="touched"
        :edit-mode="editMode"
        :helper="helper"
        />

        <setup-order-data :toExpire="setupData.toExpire" @expire="updateExpire"/>
<!--        <payment :id="id" v-if="getUser.role ==='admin'"/>-->

        <envs
        :envConfigs.sync="envConfigs"
        @bardcode="barcodeChanged"
        @currency="currencyChanged"
        @proxy="proxyChanged"
        @testregistry="testregistryChanged"
        @showBarcode="showBarcodeChanged"
        @printcubeBrand="printcubeBrandChanged"

        :data.sync="setupData"
        :edit-mode="editMode"
        :helper="helper"
        ></envs>
        <div class="panel">
        <div class="panel-footer">
            <button
            v-if="editMode"
            type="submit"
            class="btn btn-primary"
            name="save"
            >{{$t('UI.save')}}</button>

            <button
            v-else
            type="submit"
            class="btn btn-primary"
            name="next"
            >{{$t('UI.next')}}</button>

            <button
            type="button"
            class="btn btn-danger"
            name="next"
            v-on:click="cancel()"
            >{{$t('UI.cancel')}}</button>
        </div>
        </div>
    </form>
  </form>
</template>

<script type="text/babel">
import { mapActions, mapGetters, mapMutations } from 'vuex';
import _ from 'underscore';

import ShopForm from './SubForms/ShopForm.vue';
import ShopCopy from './SubForms/ShopCopy';
import Payment from './SubForms/Payment';
import { RegistrationPerimeter } from '../../../../router/perimeters/registrationPerimeter';
import Envs from './SubForms/Envs';
import SetupOrderData from "./SubForms/SetupOrderData";

export default {
    name: 'ShopRegistrationForm',
    perimeters: [RegistrationPerimeter],
    data () {
        return {
            editMode: true,
            selectedShop: {},
            helper: true,
            envConfigs: {},
            pending: false,
            touched: false,
            currentKeyAccount: null,
            keyAccountId: null,
            loadbalancer: "",
            paymentType: ''
        };
    },
    props: {
        id: {
            type: String
        }
    },
    components: {
        SetupOrderData,
        ShopForm,
        ShopCopy,
        Envs,
        Payment
    },
    computed: {
        ...mapGetters({
            currentShop: 'currentShop',
            currentSetup: 'currentSetup',
            defaultSetup: 'defaultSetup',
            getCurrentShopFormIsValid: 'getCurrentShopFormIsValid',
            getUser: 'getUser',
            getUsers: 'getUsers',
            currentPaymentMethod: 'paymentMethod',
        }),
        isNew () {
            return !this.editMode;
        },
        setupData: {
            get () {
                return this.currentSetup;
            },
            // setter
            set (setup) {
                this.UpdateCurrentSetup(setup);
            }
        },
        shop: {
            get () {
                return this.currentShop;
            },
            set (shop) {
                this.CurrentShop(shop);
            }
        }
    },
    methods: {
        updateExpire(toExpire){
          this.setupData.toExpire = toExpire;
        },
        submitForm(e){
            e.preventDefault();
            if(this.editMode)
                this.save();
            else this.next();
        },
        barcodeChanged (value) {
            this.shop.barcodeProduct = value;
        },
        getEnvValue(name, env){
            let value = ''
            this.envConfigs.forEach(({ serviceName, envs}) => {
                if(serviceName === name){
                    envs.forEach((envObj) => {
                        if(envObj.key === env){
                            value =  envObj.value
                        }
                    });
                }
            })
            return value
        },
        getLoadbalancer(){
            const cubes = this.getEnvValue('ordermanager', 'cubes')
            const [loadbalancerServer] = cubes.split(" ")
            this.loadbalancer = loadbalancerServer
        },
        currencyChanged (value) {
            this.shop.currency = { code: value };

            let isCurrency = false;
            let currencyObjectOptions = [];
            this.envConfigs.forEach(({ serviceName, envs}) => {
                if(serviceName === 'webapp' || serviceName === 'templates'){
                    envs.forEach((envObj) => {
                        if( serviceName === 'templates' && envObj.key === 'currency'){
                            envObj.value = value;
                            currencyObjectOptions = envObj.options;
                        }
                        if( serviceName === 'webapp' && envObj.key === 'currency'){
                            envObj.value = value;
                            isCurrency = true;
                        }
                    });
                }
                if(serviceName === 'webapp' && !isCurrency){
                    if(!isCurrency) {
                        envs.push({
                            key: 'currency',
                            value: value,
                            show: false,
                            onlyForAdmin: true,
                            inputType: 'select',
                            options: currencyObjectOptions
                        });
                        isCurrency = true;
                    }
                }
            });

        },
        printcubeBrandChanged (value) {
            let printcubeBrandOptions = [];
            this.envConfigs.forEach(({ serviceName, envs}) => {
                if(serviceName === 'webapp' || serviceName === 'translations'){
                    envs.forEach((envObj) => {
                        if( (serviceName === 'webapp'  || serviceName === 'translations') && envObj.key === 'printcube_brand'){
                            envObj.value = value;
                            printcubeBrandOptions = envObj.options;
                        }
                    });
                }
                if((serviceName === 'webapp'  || serviceName === 'translations') ){
                    envs.push({
                        key: 'printcube_brand',
                        value: value,
                        show: false,
                        onlyForAdmin: true,
                        inputType: 'select',
                        options: printcubeBrandOptions
                    });
                }
            });
        },
        showBarcodeChanged (value) {
            this.shop.showBarcode = value === "true" ? true : false;
        },
        proxyChanged(value) {
            if(this.setupData.installation) {
                this.setupData.installation.proxy = value;
            }else {
                this.setupData.installation = { proxy: value }
            }
        },
        testregistryChanged(value){
            if(this.setupData.installation) {
                this.setupData.installation.testregistry = value;
            }else {
                this.setupData.installation = { testregistry:  value }
            }
        },
        ...mapActions([
            'SaveShop',
            'GetShopById',
            'CurrentShop',
            'GetSetupDataById',
            'SaveSetupData',
            'GetDefaultSetup',
            'UpdateCurrentSetup',
            'SaveShopRegistrationState',
            'updateShopAsync',
            'SaveBasketData',
            'GetBasketData',
            'GetEnvConfigData',
            'SaveEnvConfigData',
            'AddShopToUser',
            'DelShopFromUser',
            'UpdateShop',
            'setRedirectionAsync',
            'deleteRedirectionAsync',
            'SetShopPaymentMethod'
        ]),
        ...mapMutations(['addAlert', 'addShop']),
        cancel () {
            this.$router.back();
        },
        async updateShop () {
            const { store } = await this.UpdateShop({
                store: this.shop,
                setup: this.setupData,
                envs: this.envConfigs
            });
            if(this.loadbalancer)
                await this.setRedirectionAsync({url: this.loadbalancer, context: this.id })
            else await this.deleteRedirectionAsync({ context: this.id })
            return store;
        },
        async createShop () {
            const { store } = await this.SaveShop({
                store: this.shop,
                setup: this.setupData,
                envs: this.envConfigs,
                user: this.getUser
            });
            await this.AddShopToUser({ user: this.getUser, shop: store });
            if(this.loadbalancer)
                await this.setRedirectionAsync({url: this.loadbalancer, context: store.id })
            return store;
        },
        async save () {
            this.getLoadbalancer()
            this.updateShop()
                .then(store => {
                    this.UpdateCurrentSetup({});
                    this.CurrentShop({});
                    this.loadbalancer = '';
                    //this.SetShopPaymentMethod({ id: store.id, paymentType: this.currentPaymentMethod });
                    this.$router.push({
                        name: 'shopsshow',
                        params: { id: store.id, showInformationUpdateCubes: true },
                    });
                })
                .catch(err => (this.pending = false));
        },
        async next () {
            this.getLoadbalancer()
            this.createShop()
                .then(store => {
                   // this.SetShopPaymentMethod({ id: store.id, paymentType: this.currentPaymentMethod });

                    this.$router.push({
                        name: 'FastEdit',
                        params: { id: store.id, fastedit: 'fastedit' }
                    });
                })
                .catch(err => {
                    this.pending = false;
                });
        },
        async selected (data) {
            const shop = _.clone(data);
            let config;

            if (data.id) {
                delete shop.id;
                if (!shop.workDays) {
                    shop.workDays = [];
                }
            }
            config = await this.GetSetupDataById(shop.setupID);

            this.envConfigs = await this.GetEnvConfigData({
                context: data.id,
                role: this.getUser.role
            });
            this.CurrentShop(shop);
            this.UpdateCurrentSetup(_.extend(this.defaultSetup, config));
        },
        isFormValid () {
            return Object.values(this.getCurrentShopFormIsValid).every(
                el => el === true
            );
        },
        setKeyAccountId (id) {
            this.keyAccountId = id;
        }
    },
    async created () {
        this.$store.commit('currentShop', {});
        const defaultSetup = await this.GetDefaultSetup();
        this.envConfigs = await this.GetEnvConfigData({ role: this.getUser.role });
        if (!this.id) {
            this.editMode = false;
        }
        try {
            if (this.isNew) {
                this.UpdateCurrentSetup(defaultSetup);
                this.getUser.role === 'key_account'
                    ? (this.shop.users = [{ id: this.getUser.id }])
                    : null;
            } else {
                const shop = await this.GetShopById(this.id);
                this.selected(shop);
            }
        } catch (err) {
            this.$router.replace({ name: '404' });
        }
    }
};
</script>
